export const getCourseUpdateError = (error, expectedUpdatedAt) => {
  if (expectedUpdatedAt && error?.code === "PGRST116") {
    return new Error(
      "This course changed in another editor. Reload it before saving again.",
    );
  }
  return new Error(error?.message || "Failed to update course");
};
